import React from "react";
import { FormattedMessage } from "react-intl";

export default function SummariesItems({ itemsData, dictionary }) {

    const valueFormat = (item) =>{
        let result;
        if(item && item.value !== undefined && item.value !== null){
            if(item.valueFormat){
                switch (item.valueFormat) {
                    case "MONEY":
                        const type = item.valueFormatCurrency ? item.valueFormatCurrency : 'COP';
                        result = item.value.toLocaleString('es-CO', {
                            style: 'currency',
                            currency: type,
                            minimumFractionDigits : 0,
                            maximumFractionDigits : 0
                        });
                        break;
                    case "NUMBER":
                        result = item.value.toLocaleString('es-CO');
                    break;

                    default:
                        result = item.value;
                        break;
                }
            } else {
                result = item.value;
            }
        } else {
            result = item.value;
        }
        return result;
    };

    return (
        <React.Fragment>
            <div className="totals">
            {itemsData?.map((items, idxItems) => {

                const processItemValue = (val, idxItem) => {
                    if(val){
                        if(val.value && typeof val.value === 'object'){
                            return (
                                val.value.map((itm, indx) => {
                                    return (
                                        <>
                                            {itm?.value !== undefined && itm?.value !== null ? 
                                            // rome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
                                            (<div key={`${idxItem}${indx}`} className="value" dangerouslySetInnerHTML={{ __html: valueFormat(itm) }} />) 
                                            : (itm !== undefined && itm?.value !== null ? 
                                                // rome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
                                                (<div key={`${idxItem}${indx}`} className="value" dangerouslySetInnerHTML={{ __html: itm }} />) 
                                                : <div key={`${idxItem}${indx}`} className="value"><i className='bi bi-question-circle-fill' /></div>)}
                                        </>
                                    );
                                })
                            );
                        } else  {
                            return (
                                <>
                                    {
                                    val.value !== undefined && val?.value !== null  ? 
                                    // rome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
                                    (<div className="row rowValue"><div key={`elm${idxItems}`} className="col-12 value" dangerouslySetInnerHTML={{ __html: valueFormat(val) }} /></div>) 
                                    : <div className="row rowValue"><div className="col-12 value"><i className='bi bi-question-circle-fill' /></div></div>}
                                </>
                            );
                        }
                    }
                };
                
                return (
                <div className={`total left_status ${items.borderLeftColor}`} key={`${items.id}${idxItems}`} >
                    
                    <div className="row name">
                        <div className="col-8">
                            <FormattedMessage id={`${dictionary}.${items.state}`} defaultMessage={items.state}/>
                        </div>
                        <div className="col-4 summariePorcentaje">
                            {items.valueP && items.valueP}
                            {items.icon && <i className={`summarieIcon ${items.icon}`} />}
                        </div>
                    </div>
                    
                    {processItemValue(items, (`${items.id}${idxItems}`))}
                </div>
                );
            })}
            </div>
        </React.Fragment>
    )
}
